import Vue from 'vue';
import VueRouter from 'vue-router';

import MainApp from '@/MainApp.vue';
import t from '@/views/extTicket.vue';
import vrShowLink from '@/views/VRShow.vue';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

const locales = process.env.avaiableLocales.map((locale) => locale.name);
locales.push('');

const routes = [
  {
    path: '/',
    component: MainApp,
    children: [
      {
        path: `:lang(${locales.join('|')})?`,
        component: {
          render: (h) => h('router-view'),
        },
        children: [
          {
            path: '/',
            name: 'Home',
            component: () =>
              import(/* webpackChunkName: "home" */ '../views/Home.vue'),
          },
          {
            path: 'overview/introduction',
            name: 'Introduction',
            component: () => import('../views/Overview/Introduction.vue'),
          },
          {
            path: 'overview/scenic-spots',
            name: 'ScenicSpots',
            component: () => import('../views/Overview/ScenicSpots.vue'),
          },
          {
            path: 'overview/scenic-spots-detail',
            name: 'ScenicSpotsDetail',
            component: () => import('../views/Overview/ScenicSpotsDetail.vue'),
          },
          {
            path: 'overview/base-info',
            name: 'BaseInfo',
            component: () => import('../views/Overview/BaseInfo.vue'),
          },
          {
            path: 'strategy/traffic',
            name: 'Traffic',
            component: () => import('../views/Strategy/Traffic.vue'),
          },
          {
            path: 'strategy/route',
            name: 'Route',
            component: () => import('../views/Strategy/Route.vue'),
          },
          {
            path: 'strategy/photo',
            name: 'Photo',
            component: () => import('../views/Strategy/Photo.vue'),
          },
          {
            path: 'strategy/note',
            name: 'Note',
            component: () => import('../views/Strategy/Note.vue'),
          },
          {
            path: 'strategy/note-detail',
            name: 'NoteDetail',
            component: () => import('../views/Strategy/NoteDetail.vue'),
          },
          {
            path: 'strategy/video',
            name: 'Video',
            component: () => import('../views/Strategy/Video.vue'),
          },
          {
            path: 'strategy/video-detail',
            name: 'VideoDetail',
            component: () => import('../views/Strategy/VideoDetail.vue'),
          },
          {
            path: 'news',
            name: 'News',
            component: () => import('../views/News.vue'),
          },
          {
            path: 'newsDetail',
            name: 'NewsDetail',
            component: () => import('../views/NewsDetail.vue'),
          },
          {
            path: 'map',
            name: 'Map',
            component: () =>
              import(/* webpackChunkName: "map" */ '../views/Map.vue'),
          },
          // {
          //   path: 'vr',
          //   name: 'VR',
          //   component: () =>
          //     import(/* webpackChunkName: "map" */ '../views/Map.vue'),
          // },
          {
            path: 'ticket',
            name: 'Ticket',
            component: () => import('@/views/Ticket.vue'),
            children: [
              {
                path: '',
                name: 'homeTicket',
                component: () =>
                  import(
                    /* webpackChunkName: "TicketSell" */
                    '../views/TicketSell/Home.vue'
                  ),
              },
              {
                path: 'buyTicket',
                name: 'BuyTicket',
                component: () =>
                  import(
                    /* webpackChunkName: "TicketSell" */
                    '../views/TicketSell/BuyTicket.vue'
                  ),
              },
              {
                path: 'orderconfirm',
                name: 'OrderConfirm',
                component: () =>
                  import(
                    /* webpackChunkName: "TicketSell" */
                    '../views/TicketSell/OrderConfirm.vue'
                  ),
              },
              {
                path: 'paysuccess',
                name: 'PaySuccess',
                component: () =>
                  import(
                    /* webpackChunkName: "TicketSell" */
                    '../views/TicketSell/PaySuccess.vue'
                  ),
              },
            ],
          },
          {
            path: 'booking',
            name: 'Booking',
            component: () => import('@/views/Booking.vue'),
            children: [
              {
                path: 'mall',
                name: 'Mall',
                component: () => import('../views/Booking/Mall.vue'),
              },
              {
                path: 'mall/detail',
                name: 'Detail',
                component: () => import('../views/Booking/Detail.vue'),
              },
              {
                path: 'mall/cart',
                name: 'Cart',
                component: () => import('../views/Booking/Cart.vue'),
              },
              {
                path: 'mall/order',
                name: 'Order',
                component: () => import('../views/Booking/Order.vue'),
              },
              {
                path: 'mall/submitOrder',
                name: 'SubmitOrder',
                component: () => import('../views/Booking/SubmitOrder.vue'),
              },
              {
                path: 'hotel',
                name: 'Hotel',
                component: () => import('../views/Booking/Hotel.vue'),
              },
              {
                path: 'restaurant',
                name: 'Restaurant',
                component: () => import('../views/Booking/Restaurant.vue'),
              },
              {
                path: 'guide',
                name: 'Guide',
                component: () => import('../views/Booking/Guide.vue'),
              },
            ],
          },
          {
            path: 'login',
            name: 'Login',
            component: () => import('../views/Login.vue'),
          },
          {
            path: 'account/ticket-order',
            name: 'TicketOrder',
            component: () => import('../views/Account/TicketOrder.vue'),
          },
          {
            path: 'account/ticket-order-detail',
            name: 'TicketOrderDetail',
            component: () => import('../views/Account/TicketOrderDetail.vue'),
          },
          {
            path: 'account/mall-order',
            name: 'MallOrder',
            component: () => import('../views/Account/MallOrder.vue'),
          },
          {
            path: 'account/mall-order-detail',
            name: 'MallOrderDetail',
            component: () => import('../views/Account/MallOrderDetail.vue'),
          },
          {
            path: 'account/contacts',
            name: 'Contacts',
            component: () => import('../views/Account/Contacts.vue'),
          },
          {
            path: 'account/profile',
            name: 'Profile',
            component: () => import('../views/Account/Profile.vue'),
          },
          {
            path: 'paySuccess',
            name: 'PaySuccess',
            component: () => import('../views/PaySuccess.vue'),
          },
          {
            path: 'payError',
            name: 'PayError',
            component: () => import('../views/PayError.vue'),
          },
          {
            path: 'pageDetail',
            name: 'PageDetail',
            component: () => import('../views/PageDetail.vue'),
          },
          {
            path: 'pages/terms-use',
            name: 'TermsUse',
            component: () => import('../views/Pages/TermsUse.vue'),
          },
          {
            path: 'pages/faq',
            name: 'FAQ',
            component: () => import('../views/Pages/FAQ.vue'),
          },
          {
            path: 'pages/contact-us',
            name: 'ContactUs',
            component: () => import('../views/Pages/ContactUs.vue'),
          },
          {
            path: 'pages/message',
            name: 'Message',
            component: () => import('../views/Pages/Message.vue'),
          },
          {
            path: 'queryTicket',
            name: 'QueryTicket',
            component: () => import('../views/QueryTicket.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/t/:code',
    name: 't',
    component: t,
  },
  {
    path: '/vrShowLink',
    name: 'vrShowLink',
    component: vrShowLink,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
  base: process.env.BASE_URL,
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
